import React from 'react';
import './Subscribe.css';

const Subscribe = () => {
  return (
    <div className="subscribe-page">
      <iframe
        src="/subscribe.html"
        title="Subscribe"
        className="subscribe-iframe"
        allow="fullscreen"
      />
    </div>
  );
};

export default Subscribe;
